import React,
{
    useState
}
from "react";

import {
    createLink
}
from "../services/shortLinkService";

export default function CreateLinkForm({
    currentUser,
    refresh
}) {

    const [shortCode,
           setShortCode] =
        useState("");

    const [title,
           setTitle] =
        useState("");

    const [destinationUrl,
           setDestinationUrl] =
        useState("");

    const [saving,
           setSaving] =
        useState(false);

    const [active,
        setActive] =
        useState(true);

    const [expiresAt,
        setExpiresAt] =
        useState("");

    async function handleSubmit(
        e
    ) {

        e.preventDefault();

        if (
            !shortCode.trim() ||
            !destinationUrl.trim()
        ) {

            alert(
                "Short code and destination URL are required."
            );

            return;

        }

        try {

            setSaving(true);

            const result =
                await createLink(
                    currentUser,
                    {
                        shortCode,
                        title,
                        destinationUrl,
                        active,
                        expiresAt:
                            expiresAt || null
                    }
                );

            if (
                result.error
            ) {

                alert(
                    result.error
                );

                return;

            }

            setShortCode("");
            setTitle("");
            setDestinationUrl("");
            setActive(true);
            setExpiresAt("");

            if (refresh) {
                await refresh();
            }

        }

        catch (error) {

            console.error(
                error
            );

            alert(
                "Unable to create link."
            );

        }

        finally {

            setSaving(false);

        }

    }

    return (

        <div className="createLinkCard">

            <h2 className = "statsInfo">
                Create a New Short Link
            </h2>

            <form
                onSubmit={
                    handleSubmit
                }
            >

                <div className="createLinkGrid">

                    <div className="formGroup">

                        <label>
                            Short Code
                        </label>

                        <input
                            type="text"
                            value={shortCode}
                            onChange={
                                e =>
                                setShortCode(
                                    e.target.value
                                )
                            }
                            placeholder="my-link"
                        />

                    </div>

                    <div className="formGroup">

                        <label>
                            Title
                        </label>

                        <input
                            type="text"
                            value={title}
                            onChange={
                                e =>
                                setTitle(
                                    e.target.value
                                )
                            }
                            placeholder="Spring Hiring Event"
                        />

                    </div>

                </div>

                <div className="formGroup">

                    <label>
                        Destination URL
                    </label>

                    <input
                        type="url"
                        value={destinationUrl}
                        onChange={
                            e =>
                            setDestinationUrl(
                                e.target.value
                            )
                        }
                        placeholder="https://example.com"
                    />

                </div>
                <div className="checkboxGroup">

                    <input
                        type="checkbox"
                        id="active"
                        checked={active}
                        onChange={
                            e =>
                            setActive(
                                e.target.checked
                            )
                        }
                    />

                    <label htmlFor="active">

                        Link Active

                    </label>

                </div>

                <div className="formGroup">

                    <label>

                        Expiration Date

                    </label>

                    <input
                        type="datetime-local"
                        value={expiresAt}
                        onChange={
                            e =>
                            setExpiresAt(
                                e.target.value
                            )
                        }
                    />
                    <p className="fieldHelp">

                        Leave blank if the link should
                        never expire.

                    </p>

                </div>

                <button
                    type="submit"
                    className="createLinkButton"
                    disabled={saving}
                >

                    {
                        saving
                            ? "Creating..."
                            : "Create Link"
                    }

                </button>

            </form>

        </div>

    );

}